import React from 'react';

const UserResetPasswordForm = ({
  password,
  confirmPassword,
  errorMessage,
  successMessage,
  loading,
  formSubmitted,
  handlePasswordChange,
  handleConfirmPasswordChange,
}) => {
  return (
    <div className="modal-column">
      <div className="form-group">
        <input
          type="password"
          name="password"
          value={password}
          onChange={handlePasswordChange} 
          placeholder="New Password"
          className={formSubmitted && !password && !successMessage ? 'missing-field' : ''}
        />
        <div className="error-message-container">
          {formSubmitted && !password && !successMessage && (
            <p className="error-message">Password is required</p>
          )}
        </div>
      </div>

      <div className="form-group">
        <input
          type="password"
          name="confirmPassword"
          value={confirmPassword}
          onChange={handleConfirmPasswordChange}
          placeholder="Confirm Password"
          className={formSubmitted && !confirmPassword && !successMessage ? 'missing-field' : ''}
        />
        <div className="error-message-container">
          {formSubmitted && !confirmPassword && !successMessage && (
            <p className="error-message">Confirming the password is required</p>
          )}
        </div>
      </div>

      {errorMessage && (
        <div className="error-message-container">
          <p className="error-message">{errorMessage}</p>
        </div>
      )}
      {successMessage && (
        <div className="success-message-container">
          <p className="success-message">{successMessage}</p>
        </div>
      )}
    </div>
  );
};

export default UserResetPasswordForm;